import React from 'react';
import { Divider } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/elements/divider.less';
import 'semantic-ui-less/definitions/elements/segment.less';
import 'semantic-ui-less/definitions/collections/grid.less';

export default Divider;
